
<template>

  <div class="modal fade" id="supportContactModal">
    <div class="modal-dialog modal-dialog-centered custom-modal-two">
      <div class="modal-content">
        <div class="page-wrapper-new p-0">
          <div class="content">
            <div class="modal-header border-0 custom-modal-header">
              <div class="page-title">
                <h4> Support Contact</h4>
              </div>
              <button type="button" class="close" data-bs-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body custom-modal-body">
              <form @submit.prevent="submitForm">
                <div class="row">
                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <label>Contact Type</label>
                      <select
                          v-model="supportContact.type"
                          required
                          class="form-control"
                      >
                        <option value="" disabled>Select contact type</option>
                        <option value="email">Email</option>
                        <option value="phone">Phone</option>
                      </select>
                    </div>
                  </div>

                  <div class="col-lg-12">
                    <div class="input-blocks">
                      <label>Contact</label>
                      <input type="text" name="title" required v-model="supportContact.contact"
                             :class="{ 'form-control': true }" />
                    </div>
                  </div>

                </div>
                <div class="modal-footer-btn">
                  <button type="button" class="btn btn-cancel me-2" data-bs-dismiss="modal">
                    Cancel
                  </button>
                  <button type="submit" class="btn btn-submit" id="submit" :disabled="isSubmitDisabled">Submit</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script setup>

import {useSupportContactStore} from "@/store/supportContactStore";
import { checkInputValidity } from '@/utils/validator';
import { computed, onMounted, reactive, ref, watch } from 'vue';
import 'bootstrap/dist/css/bootstrap.min.css';

const supportContactStore = useSupportContactStore();

const showOverlay = ref(false);

const visible = ref(false);

const formTouched = ref(false);


const setVisible = (value) => {
  visible.value = value;
};

const props = defineProps({
  supportContactId: null
});
// data
const supportContact = ref({
  type: '',
  contact: '',
});

const isSubmitDisabled = computed(() => {
  return !supportContact.value.contact || supportContact.value.contact.trim() === "";
});

async function submitForm() {

  const valid = checkInputValidity("submit");
  if (!valid) return;

  if (props.supportContactId) {
    // update
    await supportContactStore.updateSupportContact(props.supportContactId, supportContact.value);
  } else {
    // add
    await supportContactStore.addSupportContact(supportContact.value);
  }

  resetForm();
  $("#supportContactModal").modal("hide");
}

watch(() => props.supportContactId, () => {
  if (props.supportContactId) {
    supportContact.value = supportContactStore.supportContact.find(m => m.id === props.supportContactId);

  } else {
    supportContact.value = { type: '', contact: '' };
  }
}, { immediate: true });

const resetForm = () => {
  supportContact.value = {
    type: '',
    contact: '',
  };

  formTouched.value = false;
};

onMounted(() => {
  const modalEl = document.getElementById("supportContactModal");

  modalEl.addEventListener("hidden.bs.modal", () => {
    resetForm();
  });
});


</script>

<style scoped>

</style>